import { format, parse } from 'date-fns';

export const formatDateToString = (date: Date | undefined): string => {
  if (!date) {
    return '';
  }

  try {
    return format(date, 'yyyy-MM-dd');
  } catch {
    return '';
  }
};

export const parseStringToDate = (dateString: string): Date | undefined => {
  if (!dateString) {
    return undefined;
  }

  try {
    const parsed = parse(dateString, 'yyyy-MM-dd', new Date());
    return isValidDate(parsed) ? parsed : undefined;
  } catch {
    return undefined;
  }
};

export const isValidDate = (date: Date | undefined): boolean => {
  if (!date) {
    return false;
  }
  return !isNaN(date.getTime());
};

export const formatInputValue = (value: string): string => {
  const digitsOnly = value.replace(/\D/g, '');

  if (digitsOnly.length <= 4) {
    return digitsOnly;
  }
  if (digitsOnly.length <= 6) {
    return `${digitsOnly.slice(0, 4)}-${digitsOnly.slice(4)}`;
  }
  return `${digitsOnly.slice(0, 4)}-${digitsOnly.slice(4, 6)}-${digitsOnly.slice(6, 8)}`;
};

export const formatTimestamp = (date: Date | string | number): string => {
  const dateObj = date instanceof Date ? date : new Date(date);
  const options: Intl.DateTimeFormatOptions = {
    month: 'long',
    day: 'numeric',
    year: 'numeric'
  };
  const dateStr = dateObj.toLocaleDateString('en-US', options);
  const timeStr = dateObj.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', hour12: false });
  return `${dateStr}  ${timeStr}`;
};
